/// <amd-module name="DistributedTaskUI/Resources/ResourcesHub.Model" />
import { CheckIssue, ResourceCheckIssue } from "Checks/Client/Contracts/PipelinesChecks";
import { ViewType } from "Constants";
import { ResourceFilterOptions, ResourceFilters, ResourceItem, ResourcesHubData } from "DistributedTask/Client/Contracts/TaskAgent";


export interface IViewUpdatedEvent {
    selectedResourceIndex: number;
    viewType: ViewType;
}

export interface ResourcesHubDataExtended extends ResourcesHubData{
    resourceIssues? : ResourceCheckIssue[];
}

export interface ResourceItemExtended extends ResourceItem{
    issue?: CheckIssue;
}

export interface IResourcesHubState {
    resources: ResourceItemExtended[];
    dataLoaded: boolean;
    filters: ResourceFilters;
    currentState: string;
    filterBarVisibility: boolean;
    viewType: ViewType;
    selectedResourceIndex: number;
    filterOptions: ResourceFilterOptions;
    continuationToken: string;
    hasProjectLevelManagePermission: boolean;
}
